import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-htmlcss2print',
  templateUrl: './htmlcss2print.component.html',
  styleUrls: ['./htmlcss2print.component.scss'],
})
export class Htmlcss2printComponent implements OnInit {

  @Input() code: string;

  codecss: string;
  codejs: string;
  monimage: any;

  @ViewChild('idhtml', { static: true }) idhtml: ElementRef;
  @ViewChild('idcss', { static: true }) idcss: ElementRef;
  @ViewChild('idjs', { static: true }) idjs: ElementRef;
  //@ViewChild('idback', { static: true }) idback: ElementRef;

  visicss: boolean = true;
  visijs: boolean = true;
  selection = "0";

  constructor() { }

  ngOnInit() {


    this.idhtml.nativeElement.innerText = this.code[0]["html"];
    let valeur = this.code[1]["css"];
    //alert(valeur);
    if (valeur == undefined) {
      this.visicss = false;
      //document.getElementById("css1").style.display = "none";

    }
    else {
      //document.getElementById("css1").style.display = "block";
      this.visicss = true;
      this.codecss = valeur;
      this.idcss.nativeElement.innerText = valeur;
    }

    valeur = this.code[2]["js"];
    if (valeur == undefined) {
      this.visijs = false;
      //document.getElementById("js1").style.display = "none";

    }
    else {

      //document.getElementById("js1").style.display = "block";
      this.visijs = true;
      this.codejs = valeur;
      this.idjs.nativeElement.innerText = valeur;
    }



    this.monimage = this.code[0]["output"];

    //alert(JSON.stringify(this.code));
    

  }



}

